import { MCP_TOKEN_HEADER, type McpEnvironment } from '@mss_creator/shared';

/**
 * The URL of the MCP endpoint, from where the API lives. A local dev API base
 * is absolute (`http://localhost:3001`): `/mcp` hangs off it. A deployed one is
 * relative (`/api`, behind the proxy): `/mcp` is served by the page's own origin.
 */
export function mcpUrl(apiBase: string, origin: string): string {
  if (/^https?:\/\//.test(apiBase)) return `${apiBase.replace(/\/+$/, '')}/mcp`;
  return `${origin.replace(/\/+$/, '')}/mcp`;
}

/**
 * The `claude mcp add` command to paste, token included. On dev the endpoint
 * sits behind Authentik, so the admin completes the `Authorization` line with
 * their application password (spec D5); on prod only the token header is sent.
 */
export function buildClaudeCommand(
  environment: McpEnvironment,
  url: string,
  value: string,
): string {
  const lines = [`claude mcp add --transport http mss-creator-${environment} ${url} \\`];
  if (environment === 'dev') {
    lines.push(
      `  --header "Authorization: Basic <identifiant Authentik:mot de passe d'application, en base64>" \\`,
    );
  }
  lines.push(`  --header "${MCP_TOKEN_HEADER}: ${value}"`);
  return lines.join('\n');
}

const DATE_FORMAT = new Intl.DateTimeFormat('fr-FR', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/** « 12 oct. 2026 » */
export function formatTokenDate(iso: string): string {
  return DATE_FORMAT.format(new Date(iso));
}
